import React from 'react';
import { useField, useFormikContext } from 'formik';
import { NSInput } from 'bricks';
import RenderIf from 'components/RenderIf/RenderIf';
import { useAttributeSuggested } from 'components/DealForm/hooks/useSuggestedAttribute';
import { DefaultAttributes } from '../../../types';

interface CoordinatesInputProps {
    attribute: DefaultAttributes;
    showSuggestedOnly: boolean;
    className?: string;
    onCoordinatesChange?: (lat: number, lng: number) => void;
}

const CoordinatesInput: React.FC<CoordinatesInputProps> = ({
    attribute,
    showSuggestedOnly,
    className = '',
    onCoordinatesChange,
}) => {
    const [latField, latMeta] = useField('latitude');
    const [lngField, lngMeta] = useField('longitude');
    const { setFieldValue } = useFormikContext();

    const { isRequired, shouldRender } = useAttributeSuggested({
        attribute,
        showSuggestedOnly,
    });

    const handleCoordinateChange = (field: string) => (e: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = e.target;
        setFieldValue(field, value);

        const lat = field === 'latitude' ? Number(value) : Number(latField.value);
        const lng = field === 'longitude' ? Number(value) : Number(lngField.value);

        if (onCoordinatesChange) {
            onCoordinatesChange(lat, lng);
        }
    };

    return (
        <RenderIf isTrue={shouldRender}>
            <div className={`d-flex ${className}`}>
                <div className="w-50 mr-2">
                    <NSInput
                        type="number"
                        label="Latitude"
                        placeholder="Enter latitude"
                        errorMsg={latMeta.touched && latMeta.error ? latMeta.error : null}
                        showErrorMsg={!!(latMeta.touched && latMeta.error)}
                        required={isRequired}
                        {...latField}
                        onChange={handleCoordinateChange('latitude')}
                    />
                </div>
                <div className="w-50">
                    <NSInput
                        type="number"
                        label="Longitude"
                        placeholder="Enter longitude"
                        errorMsg={lngMeta.touched && lngMeta.error ? lngMeta.error : null}
                        showErrorMsg={!!(lngMeta.touched && lngMeta.error)}
                        required={isRequired}
                        {...lngField}
                        onChange={handleCoordinateChange('longitude')}
                    />
                </div>
            </div>
        </RenderIf>
    );
};

export default CoordinatesInput;
